<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

  import {onMount} from 'svelte';
  import Modal from '../Modal.svelte';
  import Button from '../Button.svelte';
  import {submit} from '../Form/utils.js';
  import Errors from '../Errors.svelte';
  import {get} from '../../utils.js';
  import {sgettext} from '../../i18n.js';
  import RelatedActivitiesDataTable from '../GlobalHazard/RelatedActivitiesDataTable.svelte';
  import TextInput from '../TextInput.svelte';
  import yup, { object, string } from 'yup';
  import { validateForm } from '../Form/utils.js';

  export let id = 'expireBranchHazardControlForm';
  export let expireMode = true;
  $: title = expireMode? sgettext('$$DISABLE_BRANCH_RISK_CONTROL$$') : sgettext('$$ENABLE_BRANCH_RISK_CONTROL$$');
  export let bhcId = null;
  export let actionUrl = `${PATH_PREFIX}/sw/api/branchhazardscontrols/`;
  export let getBHCDetailApi = `${PATH_PREFIX}/sw/api/branchhazardscontrols/expire_detail/`;
  export let onSubmit = (data) => data;
  export let global_hazard_id = 0;
  export let global_control_id = 0;
  export let branch_id = 0;

  let disableExpiry = false;
  let sending = false;
  let branchHazardControl;
  let formErrors = null;

  let schema = object().shape({
    expiry_reason: string()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$'))
  });

  let fieldIsValid = getDefaultFieldIsValid();

  function getDefaultFieldIsValid() {
    return {
      expiry_reason: {
        isValid: true,
        errors: '',
      }
    };
  }

  async function getBranchHazardControl() {
    if(bhcId) {
      const response = await get(`${getBHCDetailApi}?bhcId=${bhcId}`);
      const json = await response.json();
      branchHazardControl = json;
    }
  }

  async function expire() {
    sending = true;
    let method = 'PATCH';
    let url = `${actionUrl}${bhcId}/`;

    try {
      await validateForm(schema, branchHazardControl);
      await submit(url, method, {expired: expireMode, expiry_reason: branchHazardControl.expiry_reason, control_owner: branchHazardControl.control_owner});
      sending = false;
      onSubmit();
    } catch(error) {
      sending = false;

      console.log(error);
      if(error.hasOwnProperty('errors')) {
        formErrors = error.errors[0];
      }
    }
  }

  async function fetchDisableExpiryStatus(branch_hazard_control_id) {
    let dataUrl = `${PATH_PREFIX}/sw/api/bhc-usage-in-activities/${branch_hazard_control_id}/material-risk-status/`;

    try {
        let resp = await get(dataUrl);
        resp = await resp.json();
        disableExpiry = resp["is_template_pending_approval"]
    } catch (err) {
        formErrors = err;
        console.error(err);
    }
  }

  $: if (bhcId) {
    fetchDisableExpiryStatus(bhcId);
  }

  onMount(() => {
    jQuery(`#${id}`).on('show.bs.modal', function() {
      getBranchHazardControl();
    });
    jQuery(`#${id}`).on('hide.bs.modal', function() {
      global_hazard_id = 0;
      global_control_id = 0;
    });
  });
</script>

<Modal {id} {title} backdrop={'static'} large={true}>
  <div slot="body">
    {#if expireMode}
      <p>
        {sgettext(
          '$$SURE_WANT_DISABLE_FOLLOWING_RISK_CONTROL$$'
        )}
      </p>
    {:else}
      <p>
        {sgettext(
          '$$SURE_WANT_ENABLE_FOLLOWING_RISK_CONTROL$$'
        )}
      </p>
    {/if}

    {#if branchHazardControl}
      <label>{sgettext('$$RISK$$')}</label>
      <div>{branchHazardControl.global_hazard.name}</div>
      <br />
      <label>{sgettext('$$CONTROL$$')}</label>
      <div>{branchHazardControl.global_control.name}</div>
      <div>{branchHazardControl.global_control.description}</div>

      <div class="pt-3 mb-3">
        <TextInput
          id="expiry_reason"
          label={sgettext('$$REASON$$')}
          bind:isValid={fieldIsValid.expiry_reason.isValid}
          bind:errors={fieldIsValid.expiry_reason.errors}
          bind:value={branchHazardControl.expiry_reason}
          object={branchHazardControl}
          {schema}
        />
      </div>

      {#if formErrors}
        <Errors errors={formErrors} />
      {/if}
    {/if}

    {#if global_hazard_id > 0 && global_control_id > 0}
      <div class="mt-4">
        <RelatedActivitiesDataTable branchHazardControlId={bhcId} />
      </div>
    {/if}

    {#if expireMode}
      <div class="alert alert-warning" role="alert">
        {sgettext(
          '$$NOTE_ELEMENTS_USING_COMBINATION_BECOME$$'
        )}
        {sgettext(
          '$$ACTIVITIES_CONTAINING_ELEMENTS_ALSO$$'
        )}
      </div>
    {/if}
  </div>
  <div slot="footer" class="footer">
    <button
      data-dismiss="modal"
      type="button"
      class="btn btn-secondary"
      disabled={sending}>{sgettext('$$NO$$')}</button
    >
    <span
      title={disableExpiry
        ? sgettext(
            '$$BRANCH_RISK_CONTROL_CANNOT_EXPIRED$$'
          )
        : ''}
    >
      <Button
        type="primary"
        disabled={disableExpiry}
        on:click={expire}
        {sending}
        name={sgettext('$$YES$$')}
      />
    </span>
  </div>
</Modal>

<style>
  label {
    font-weight: bold;
    margin: 0;
  }

  .alert {
    margin-top: 30px;
  }

  .footer :global(.btn) {
    margin-left: 15px;
    min-width: 100px;
  }
</style>
